/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiKey = zod
	.object({
		api_key: zod.string().describe('The full API key')
	})
	.describe('The full API key (only shown once at creation)');

export type ApiKey = zod.input<typeof ApiKey>;
export type ApiKeyOutput = zod.output<typeof ApiKey>;
